export const CLASS_ROOT = 'idsk-header-web'
